import {
  ATTENTIVE_CLIENT_ID,
  FACEBOOK_CLIENT_ID,
  GMAIL_CLIENT_ID,
  REDO_MERCHANT_SERVER_URL,
} from "@redotech/redo-merchant-app-common/config";

export const instagramConnectData = {
  display: "page",
  extras: '{"setup":{"channel":"IG_API_ONBOARDING"}}',
  response_type: "code",
};

export const getInstagramAuthUrl = (
  redirectUri: string,
  signedState: string,
) => {
  return `https://www.facebook.com/v19.0/dialog/oauth?client_id=${FACEBOOK_CLIENT_ID}&display=${instagramConnectData.display}&extras=${instagramConnectData.extras}&redirect_uri=${redirectUri}&response_type=${instagramConnectData.response_type}&config_id=${process.env.INSTAGRAM_BUSINESS_CONFIG_ID}&state=${signedState}`;
};

export const facebookConnectData = { response_type: "code" };
export const getFacebookUserAuthUrl = (
  redirectUri: string,
  signedState: string,
) => {
  return `https://www.facebook.com/v19.0/dialog/oauth?client_id=${FACEBOOK_CLIENT_ID}&redirect_uri=${redirectUri}&response_type=${facebookConnectData.response_type}&config_id=${process.env.FACEBOOK_USER_CONFIG_ID}&state=${signedState}`;
};

export const getFacebookBusinessAuthUrl = (
  redirectUri: string,
  signedState: string,
) => {
  return `https://www.facebook.com/v19.0/dialog/oauth?client_id=${FACEBOOK_CLIENT_ID}&redirect_uri=${redirectUri}&response_type=${facebookConnectData.response_type}&config_id=${process.env.FACEBOOK_BUSINESS_CONFIG_ID}&state=${signedState}`;
};

export const attentiveConnectData = {
  attentiveAppStoreUrl: "https://ui.attentivemobile.com/integrations",
};

export const getAttentiveAuthUrl = (redirectUri: string, signedState: string) =>
  `https://ui.attentivemobile.com/integrations/oauth-install?client_id=${ATTENTIVE_CLIENT_ID}&redirect_uri=${redirectUri}&state=${signedState}`;

// Copied from gmail/connect.tsx
export const buildGmailAuthUrl = (signedState: string) => {
  const REDIRECT_URI = `${REDO_MERCHANT_SERVER_URL}/support/config/gmail/`;
  const RESPONSE_TYPE = "code";
  const SCOPES =
    "https://mail.google.com/ https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile";

  return `https://accounts.google.com/o/oauth2/auth?client_id=${GMAIL_CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=${RESPONSE_TYPE}&scope=${SCOPES}&access_type=offline&prompt=consent&state=${signedState}`;
};

// Copied from outlook/connect.tsx
export const buildOutlookAuthUrl = (signedState: string) => {
  const scopes =
    "email offline_access openid profile User.Read Mail.ReadWrite Mail.Send MailboxSettings.Read";

  //TODO USE ENV VARIABLE FOR OUTLOOK CLIENT ID
  return `https://login.microsoftonline.com/common/oauth2/v2.0/authorize?client_id=cf2642d5-87d0-499e-91c9-62635dc4f72e&scope=${scopes}&response_type=code&state=${signedState}`;
};

export const initiateEmailReconnection = (
  emailType: "gmail" | "outlook",
  signedState: string,
) => {
  const authUrl =
    emailType === "gmail"
      ? buildGmailAuthUrl(signedState)
      : buildOutlookAuthUrl(signedState);

  location.href = authUrl;
};
